export const getDisplayName = (
  firstName: string | undefined | null,
  lastName: string | undefined | null,
  email: string | undefined | null,
): string => {
  if (firstName) {
    if (lastName) return `${firstName} ${lastName}`;
    else return firstName;
  } else if (lastName) return lastName;
  else if (email) return email;
  else return "";
};
